import { render } from "./RuiHazmat.vue?vue&type=template&id=37935cec"
const script = {}
script.render = render

export default script